import { animate, style, transition, trigger } from '@angular/animations'

export const SLIDE_DOWN_TRIGGER = trigger('slideDown', [
  transition(':enter', [
    style({ transform: 'translate3d(0, -20%, 0) scaleY(0.5)', opacity: 0 }),
    animate('250ms ease-out', style({ transform: 'translate3d(0, 0, 0) scaleY(1)', opacity: 1 })),
  ]),
  transition(':leave', [
    style({ transform: 'translate3d(0, 0, 0) scaleY(1.0)', opacity: 1 }),
    animate('250ms ease-in', style({ transform: 'translate3d(0, -20%, 0) scaleY(0.5)', opacity: 0 })),
  ]),
])
export const SLIDE_LEFT_TRIGGER = trigger('slideLeft', [
  transition(':enter', [
    style({ transform: 'translate3d(20%, 0, 0) scaleX(0.5)', opacity: 0 }),
    animate('250ms ease-out', style({ transform: 'translate3d(0, 0, 0) scaleX(1)', opacity: 1 })),
  ]),
  transition(':leave', [
    style({ transform: 'translate3d(0, 0, 0) scaleX(1.0)', opacity: 1 }),
    animate('250ms ease-in', style({ transform: 'translate3d(20%, 0, 0) scaleX(0.5)', opacity: 0 })),
  ]),
])
